import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOff from '@mui/icons-material/HighlightOff';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import Info from '@mui/icons-material/Info';
import IInfoBoxProps from '../models/info-box.props.interface';

const InfoBox: React.FC<IInfoBoxProps> = ({ type, closeable, children }) => {
  const [closed, setClosed] = useState(false);

  return !closed ? (
    <div className='info-box'>
      <div className='w-100 d-flex justify-content-start align-items-center'>
        <div className={`icon-wrapper ${type}`}>
          {type === 'error' && <HighlightOff />}
          {type === 'success' && <CheckCircleOutline />}
          {type === 'warning' && <ErrorOutline />}
          {type === 'info' && <Info />}
        </div>
        <div className={`content-box ${type}`}>
          {children}
          {closeable && <CloseIcon onClick={() => setClosed(true)} />}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default InfoBox;
